import {otsBaseApi} from "../../ots-api";
import {RateModel, RateModelSearchCriteria} from "../../../model/rate-model";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["RateModels"]});

const pipelineApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRateModels: builder.query<RateModel[], string | undefined>({
      query: (regionId) => ({
        url: `/rate-models/all`,
        method: "GET",
        params: buildParams(regionId)
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "RateModels", id} as const)),
            {type: "RateModels", id: "LIST"}
          ];
        } else {
          return [{type: "RateModels", id: "LIST"}];
        }
      }
    }),
    getRateModel: builder.query<RateModel, string>({
      query: (id) => ({
        url: `/rate-models/${id}`,
        method: "GET",
        params: buildParams()
      }),
      providesTags: (result, error, id) => [{type: "RateModels", id}]
    }),
    searchRateModels: builder.query<
      RateModel[],
      RateModelSearchCriteria
    >({
      query: (criteria) => ({
        url: `/rate-models/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "RateModels", id} as const)),
            {type: "RateModels", id: "LIST"}
          ];
        } else {
          return [{type: "RateModels", id: "LIST"}];
        }
      },
    }),
  })
});

const buildParams = (regionId?: string) => {
  const extrasParams = {};

  if (regionId) {
    return {
      regionId: regionId,
      ...extrasParams
    };
  } else {
    return extrasParams;
  }
};

export const {
  useGetAllRateModelsQuery,
  useGetRateModelQuery,
  useSearchRateModelsQuery,
} = pipelineApi;
